import { PlatformMeta } from '@apparel/core/platform/PlatformMeta';
import { PlatformTag } from '@apparel/core/platform/types';
import { useMemo } from 'react';
import { usePlatform } from './usePlatform';

export function usePlatformMeta(defaultPlatform?: PlatformTag) {
    const platform = usePlatform(defaultPlatform);
    return useMemo(() => PlatformMeta.getBasedOnPlatform(platform), [platform]);
}
